export const IconCandidatesRefused: {
  name: 'icon_candidates_refused-11e5f7252e05'
} = {
  name: 'icon_candidates_refused-11e5f7252e05'
}
